export default __webpack_public_path__ + "static/media/powered_by_morningstar.e349a273.png";